import { render, staticRenderFns } from "./AddHoliday.vue?vue&type=template&id=7be8cf46"
import script from "./AddHoliday.vue?vue&type=script&lang=js"
export * from "./AddHoliday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports